<template>
  <div
    class="sign-up-loading"
    data-testid="sign-up-loading"
    role="status"
    :aria-label="t('Loading')"
  >
    <LoaderIcon />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import LoaderIcon from '@monolith/legacy/components/loader-icon.vue';

defineOptions({
  name: 'SignUpLoading',
  // Vue builds the loading component with the async wrapper's own vnode props
  // (createInnerComp forwards parent.vnode.props), so every binding on <SignUp> --
  // analytic-props, device-id, the listeners -- would land on this root otherwise.
  inheritAttrs: false,
});

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.sign-up-loading {
  // Both hosts lay out before the chunk resolves -- the modal frame opens on its own watch,
  // and register-page's __body has no height of its own -- so without a floor here this
  // paints as a strip of padding and then jumps to full height once the wizard arrives.
  @apply ds-flex ds-items-center ds-justify-center ds-min-h-[320px];
}
</style>
